// Contract addresses for different networks (loaded from env)
const SHOP_CONTRACT_ADDRESSES = {
  testnet: import.meta.env.VITE_SHOP_CONTRACT_TESTNET,
  mainnet: import.meta.env.VITE_SHOP_CONTRACT_MAINNET,
} as const;

// Select contract address based on network
const isTestnet = import.meta.env.VITE_IS_TESTNET === 'true';
export const SHOP_CONTRACT_ADDRESS = (
  isTestnet ? SHOP_CONTRACT_ADDRESSES.testnet : SHOP_CONTRACT_ADDRESSES.mainnet
) as `0x${string}`;

// Import ABI from artifact
import STDMarketplaceArtifact from './STDMarketplace.json';
export const SHOP_CONTRACT_ABI = STDMarketplaceArtifact.abi;

